// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__nP3M4","navMenu":"NavBar_navMenu__oz19L","mobile":"NavBar_mobile__3S__F"};